import {
  all, call, put, select, take,
} from 'redux-saga/effects';
import {
  compact, compose, find,
  filter, get, identity,
  map, reject, some,
  toString, uniqWith,
} from 'lodash/fp';
import * as errorActions from '../errors/actions';
import * as contactsServices from '../contacts/services';
import * as actions from './actions';
import * as services from './services';

export function* createContact() {
  while (true) {
    try {
      const action = yield take(actions.CREATE_CONTACT_REQUEST);

      const { values, sid } = action.payload;

      const clazzGroup = compose(
        get('value'),
        find(group => group.type === 'clazzGroup'),
      )(values.student.groups);
      const customGroups = compose(
        map(group => group.value),
        filter(group => group.type === 'customGroup'),
      )(values.student.groups);

      const contact = yield call(services.createContact, {
        sid,
        clazzGroup,
        customGroups,
        clazzNumber: values.student.clazzNumber,
        email: values.student.email,
        name: values.student.name,
        phoneNumber: values.student.phoneNumber,
      });

      yield all(compact([
        call(services.createGuardianContact, {
          cid: contact.data.id,
          level: 'primary',
          email: values.primaryGuardian.email,
          name: values.primaryGuardian.name,
          phoneNumber: values.primaryGuardian.phoneNumber,
          relationship: values.primaryGuardian.relationship,
        }),
        some(identity, values.secondaryGuardian) && call(services.createGuardianContact, {
          cid: contact.data.id,
          level: 'secondary',
          email: values.secondaryGuardian.email,
          name: values.secondaryGuardian.name,
          phoneNumber: values.secondaryGuardian.phoneNumber,
          relationship: values.secondaryGuardian.relationship,
        }),
      ]));

      yield put(actions.createContactSuccess());
    } catch (error) {
      yield put(actions.createContactFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

function* createContactsSubtask({ values, sid, createdClazzGroups }) {
  try {
    const groups = yield select(state => state.contacts.groups);

    const clazzGroups = get('clazzGroups', groups.data);

    const contact = yield call(services.createContact, {
      sid,
      clazzGroup: get('id', find(group => (
        toString(group.grade) === toString(values.student.grade) && group.class_name === toString(values.student.clazzName)
      ), [...clazzGroups, ...createdClazzGroups])),
      clazzNumber: values.student.clazzNumber,
      email: values.student.email,
      name: values.student.name,
      phoneNumber: values.student.phoneNumber,
    });

    yield call(services.createGuardianContact, {
      cid: contact.data.id,
      level: 'primary',
      email: values.primaryGuardian.email,
      name: values.primaryGuardian.name,
      phoneNumber: values.primaryGuardian.phoneNumber,
      relationship: values.primaryGuardian.relationship,
    });

    yield put(actions.createContactsSubtaskSuccess());
  } catch (error) {
    yield put(actions.createContactsSubtaskFailure());
  }
}

export function* createContacts() {
  while (true) {
    try {
      const action = yield take(actions.CREATE_CONTACTS_REQUEST);

      const { contacts, sid } = action.payload;

      const groups = yield select(state => state.contacts.groups);

      const clazzGroups = get('clazzGroups', groups.data);

      const nonExistentClazzGroups = compose(
        map(contact => ({ grade: contact.student.grade, clazzName: toString(contact.student.clazzName) })),
        reject(contact => (
          !contact.student.clazzName
            || find(group => toString(group.grade) === toString(contact.student.grade) && group.class_name === toString(contact.student.clazzName), clazzGroups)
        )),
        uniqWith((a, b) => (
          a.student.grade === b.student.grade && a.student.clazzName === b.student.clazzName
        )),
      )(contacts);

      const responses = yield all(map(clazzGroup => call(contactsServices.createClazzGroup, { ...clazzGroup, sid }), nonExistentClazzGroups));

      const createdClazzGroups = map(response => response.data, responses);

      /* eslint-disable no-restricted-syntax */
      for (const contact of contacts) {
        yield call(createContactsSubtask, {
          values: contact,
          createdClazzGroups,
          sid,
        });
      }

      yield put(actions.createContactsSuccess());
    } catch (error) {
      yield put(actions.createContactsFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

// export function* createContacts() {
//   while (true) {
//     try {
//       const action = yield take(actions.CREATE_CONTACTS_REQUEST);

//       const { contacts, sid } = action.payload;

//       const groups = yield select(state => state.contacts.groups);

//       const clazzGroups = get('clazzGroups', groups.data);

//       const nonExistentClazzGroups = compose(
//         map(contact => ({ grade: contact.student.grade, clazzName: toString(contact.student.clazzName) })),
//         reject(contact => (
//           !contact.student.clazzName
//             || find(group => group.grade === contact.student.grade && group.class_name === toString(contact.student.clazzName), clazzGroups)
//         )),
//         uniqWith((a, b) => (
//           a.student.grade === b.student.grade && a.student.clazzName === b.student.clazzName
//         )),
//       )(contacts);

//       const responses = yield all(map(clazzGroup => call(contactsServices.createClazzGroup, { ...clazzGroup, sid }), nonExistentClazzGroups));

//       const createdClazzGroups = map(response => response.data, responses);

//       const newClazzGroups = [...clazzGroups, ...createdClazzGroups];

//       // XXX: for 문을 사용하지 않고 몇 회가 될 지 모를 비동기 요청을 순차적으로 처리할 방법은 없을까?
//       const failedContacts = [];

//       /* eslint-disable no-restricted-syntax */
//       for (const chunkedContacts of chunk(100, contacts)) {
//         const response = yield call(services.createContacts, {
//           contacts: map(contact => ({
//             class_group_id: get('id', find(group => (
//               group.grade === contact.student.grade && group.class_name === toString(contact.student.clazzName)
//             ), newClazzGroups)),
//             number: contact.student.clazzNumber,
//             email: contact.student.email,
//             name: contact.student.name,
//             mobile: contact.student.phoneNumber,
//           }), chunkedContacts),
//           sid,
//         });

//         failedContacts.push(response.data);
//       }

//       yield put(actions.createContactsSuccess({ faieldContacts: flatMap(failedContacts) }));
//     } catch (error) {
//       yield put(actions.createContactsFailure({ error }));
//     }
//   }
// }
